<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<div class="container">

			<div class="import-box" style="max-width: 560px;">
				<h2 class="mt-4 text-center">Solicitar entrega</h2>
				<p>
					
				</p>
			</div>

			<div class="container">
				<div class="row">
					<div class="col-6">

						<div class="form-group">
							<label>Buscar vehículos</label>
							<div class="input-group">
								<input type="text" 
									class="form-control" 
									placeholder="Chasis, motor, marca, modelo" 
									v-model="searchTerms"
									>
								<div class="input-group-append">
									<button @click="searchCars()" class="btn btn-outline-secondary" type="button">Buscar</button>
								</div>
							</div>
						</div>

						<div class="label mt-4">
							Vehículos habilitados para entregar
						</div>

						<div class="alert alert-warning" v-if="!loading && cars.length==0">
							No se han encontrado vehículos habilitados pare entregar que coincidan con: {{searchTerms}}
						</div>

						<table class="table mt-2 mb-4" v-if="cars.length>0">
							<tr class="table-head">
								<td>Chasis</td>
								<td>Vehículo</td>
								<td>Cliente</td>
							</tr>
							<tr v-for="item of cars" :key="item.id"  @click="selectCar(item)">
								<td>
									<div class="tc">
										<span>{{item.chassis_number}}</span>
										<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.brand.title}}</span>
										<span >{{item.model}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.client.name}}</span>
										<span >{{item.client.business_name}}</span>
									</div>
								</td>
							</tr>
						</table>

					</div>


					<div class="col-6">

						<b-form-group label="Empresa / concesionario que retira" >
							<b-form-input
								v-model="form.delivery_to_business"
								placeholder="Nombre de la empresa o concesionario que retira"
								:class="{'is-invalid':validation.hasError('form.delivery_to_business')}"
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el nombre o concesionario que retira</b-form-invalid-feedback>
						</b-form-group>
						
						<b-form-group label="Nombre transportista" >
							<b-form-input
								v-model="form.delivery_to_carrier"
								placeholder="Nombre transportista"
							></b-form-input>
						</b-form-group>
					
						<b-form-group label="Fecha de retiro sugerida" >
							<date-picker 
								v-model="form.delivery_requested_date" 
								:class="{'is-invalid':validation.hasError('form.delivery_requested_date')}"
								type="date"
								value-type="YYYY-MM-DD" 
								format="DD-MM-YYYY"
								:disabled-date="disabledPeriodDate"
							></date-picker>
							<!-- <b-form-input
								v-model="form.dua_dispatch"
								placeholder="Número de dua"
								:class="{'is-invalid':validation.hasError('form.dua_dispatch')}"
							></b-form-input> -->
							<b-form-invalid-feedback>Ingrese la fecha que desea retirar los vehículos</b-form-invalid-feedback>
						</b-form-group>

						<div class="alert alert-warning">La fecha de retiro queda sujeta a confirmacion por parte de la terminal</div>

						<div class="label">
							Vehículos seleccionados para entregar
						</div>

						<div class="alert alert-danger" v-if="validation.hasError('form.cars')">Debe seleccionar al menos un vehículo</div>

						<table class="table mt-2 mb-4" v-if="form.cars.length>0">
							<tr class="table-head">
								<td>Chasis</td>
								<td>Vehículo</td>
								<td>Cliente</td>
								<td></td>
							</tr>
							<tr v-for="(item, index) of form.cars" :key="item.id" >
								<td>
									<div class="tc">
										<span>{{item.chassis_number}}</span>
										<span><div class="car-status-point" :class="item.status"></div>{{item.statusText}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.brand.title}}</span>
										<span >{{item.model}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.client.name}}</span>
										<span >{{item.client.business_name}}</span>
									</div>
								</td>
								<td>
									<div class="btn btn-xs btn-light" @click="deselectCar(index)"><i class="fa fa-times"></i></div>
								</td>
							</tr>
						</table>

						<div class="overflow-hidden mt-3">
							<button type="submit" class="btn btn-primary pull-right" @click="save()" >Confirmar solicitud</button>
						</div>

					</div>

				</div>
			</div>

			
		</div>
	</div>

	<Loader :show="saving || loading"></Loader>
	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'requestDeliveryModal',
	components:{
		Navbar,
		Loader,
	},
	mixins: [mixins],
	data () {
		return {
			searchTerms:null,
			form: {
				delivery_to_business: null,
				delivery_to_carrier: null,
				delivery_requested_date: null,
				cars:[]
			},
			cars: [],
			loading: false,
			saving: false,
		}
	},
	computed: {
		// filteredCars: function () {
		// 	return this.cars.filter((car) => {
		// 		if( this.form.cars.map( el => el.id ).indexOf(car.id) < 0 ){
		// 			return car
		// 		}
		// 	}
		// )}
	},
	beforeMount(){
		// this.searchCars()
	},
	validators: {
		'form.delivery_to_business': function (value) {
			return Validator.value(value).required();
		},
		'form.delivery_requested_date': function (value) {
			return Validator.value(value).required();
		},
		'form.cars': function (value) {
			return Validator.custom( () => {
				if(value.length<=0){
					return true
				}
			})
		},
	},
	methods: {
		disabledPeriodDate(date) {
			var yesterday = new Date()
			yesterday.setDate(yesterday.getDate())
			return date < yesterday
		},
		selectCar(event){
			this.form.cars.push(event)
		},
		deselectCar(index){
			this.form.cars.splice(index,1)
		},
		searchCars(){
			// this.loading = true
			this.$apollo.query({
				query: gql`query ($status: String, $search: String) {
					carsAll(status: $status, search: $search) {
						id
						client{
							name
						}
						model
						brand{
							title
						}
						motor_number
						chassis_number
						status
						statusText
					}
				}`,
				variables: {
					search: this.searchTerms,
					status: 'CAN_REQUEST_DELIVERY',
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
				this.loading = false
				this.cars = data.data.carsAll;
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				var cars = []
				this.form.cars.forEach(car=>{cars.push(car.id)})
				let dataInput = {
					delivery_to_business: 		this.form.delivery_to_business,
					delivery_to_carrier: 		this.form.delivery_to_carrier,
					delivery_requested_date: 	this.form.delivery_requested_date,
					cars: 						cars
				}
				this.create(dataInput)
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data: RequestDeliveryInput! ){
					requestDelivery( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Solicitud realizada correctamente')
				this.$router.push('/cars');
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
	}
}


</script>


<style lang="scss">

</style>